import { render, staticRenderFns } from "./train.vue?vue&type=template&id=1f5a6e12"
import script from "./train.vue?vue&type=script&lang=js"
export * from "./train.vue?vue&type=script&lang=js"
import style0 from "./train.vue?vue&type=style&index=0&id=1f5a6e12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports